import { useContext, useEffect, useState } from 'react'
import { AuthFormWrapper } from '../../components/Authentication/AuthFormWrapper'
import Logo from '../../../src/assets/logo.svg'
import { emailValidator, passwordValidator, fullNameValidator, contactValidator } from '../../utils/validator'
import { DataProvider } from '../../store/ContextProvider'
import { AlertMessage } from '../../layouts/ui/AlertMessage'
import { SignupService } from '../../services/Authentication/SignupService'
import { OTPController } from '../../layouts/ui/OTPController'
import { OTPService } from '../../services/Authentication/OTPService'
import CustomInput from '../../layouts/ui/CustomInput'
import PrivacyPolicyModal from '../../components/PrivacyPolicyModal'
import { useLocation, useNavigate } from 'react-router-dom'


export const Signup = () => {
    const { BeURL, setCurrentUser, setIsAuth, showAlert } = useContext(DataProvider)
    const navigate = useNavigate()
    const [isApproval] = useState(true);
    const [form, setForm] = useState({
        fullName: '',
        email: '',
        contact: '',
        password: '',
        confrimPassword: '',
        isAgree: false
    })

    const [errors, setErrors] = useState({
        fullName: "",
        email: "",
        contact: "",
        password: "",
        confrimPassword: "",
        isAgree: ""
    });
    const [isValid, setIsValid] = useState(false);

    const [otp, setOtp] = useState(["", "", "", "", "", ""]);
    const [message, Setmessage] = useState(null)
    const [confirm, setConfirm] = useState(false)
    const [isOpen, setIsOpen] = useState(false)
    const [open, setOpen] = useState(false)
    const [signUp, setSignUP] = useState(false)


    const location = useLocation();
    const jobId = location.state?.jobId;
    const status = location.state?.status

    const handleValidation = (name, value, currentForm = form) => {
        let newErrors = { ...errors };

        if (name === "fullName") {
            newErrors.fullName = fullNameValidator(value);
        }
        if (name === "email") {
            newErrors.email = emailValidator(value);
        }
        if (name === "contact") {
            newErrors.contact = contactValidator(value);
        }
        if (name === "password") {
            newErrors.password = passwordValidator(value);
            // Check against current confirm password
            if (currentForm.confrimPassword) {
                if (currentForm.confrimPassword !== value) {
                    newErrors.confrimPassword = "Passwords do not match";
                } else {
                    newErrors.confrimPassword = "";
                }
            }
        }
        if (name === "confrimPassword") {
            if (value && currentForm.password !== value) {
                newErrors.confrimPassword = "Passwords do not match";
            } else if (!value) {
                newErrors.confrimPassword = passwordValidator(value);
            } else {
                newErrors.confrimPassword = "";
            }
        }

        setErrors(newErrors);

        // Check if form is valid
        const isFormValid =
            !newErrors.fullName &&
            !newErrors.email &&
            !newErrors.contact &&
            !newErrors.password &&
            !newErrors.confrimPassword &&
            currentForm.fullName &&
            currentForm.email &&
            currentForm.contact &&
            currentForm.password &&
            currentForm.confrimPassword;

        setIsValid(isFormValid);
    };


    const handleChange = (e) => {
        const { name, value, checked, type } = e.target;
        const newValue = type === "checkbox" ? checked : value;

        const updatedForm = {
            ...form,
            [name]: newValue
        };

        setForm(updatedForm);
        handleValidation(name, newValue, updatedForm);
    };


    const handleSendOtpForSignup = () => {
        if (!form.isAgree) {
            setErrors({ ...errors, isAgree: "You must agree to continue" })
            return
        }
        if (!isValid) {
            showAlert("All fields are required. Please fill all fields and try again!");
            return;
        }
        OTPService({
            BeURL,
            email: form.email,
            Setmessage,
            setConfirm,
            setIsOpen,
            purpose: "signup",
        });
    };


    useEffect(() => {
        if (signUp) {
            SignupService({ BeURL, form, otp, isApproval, Setmessage, setConfirm, setCurrentUser, setIsAuth })
        }
    }, [signUp])


    const handleLogin = () => {
        navigate('/login', { state: { jobId, status } })
    }

    return (
        <AuthFormWrapper>
            <div className="w-full max-w-md mx-auto md:py-8 lg:px-10 space-x-3 md:space-y-6">

                {/* Logo */}
                <div className="flex justify-center">
                    <img src={Logo} alt="" className="w-28 md:w-36" />
                </div>

                {/* Headings */}
                <div className="space-y-1 text-center">
                    <p className="text-lg md:text-2xl font-bold text-gray-700">
                        Create Your Account
                    </p>
                    <p className="text-sm text-gray-500">
                        Start your career journey today.
                    </p>
                </div>

                {/* form */}
                <form
                    className="space-y-4 mt-6 md:mt-10"
                    onSubmit={(e) => e.preventDefault()}
                >

                    {/* Full name */}
                    <CustomInput
                        label="Full Name"
                        mandatory
                        name="fullName"
                        value={form.fullName}
                        onChange={handleChange}
                        error={errors.fullName}
                        type="text"
                        pattern="^[A-Za-z]+$"
                        title="Only letters are allowed"
                        placeholder="Enter your full name"
                        required
                        className="w-full"
                    />

                    <CustomInput
                        label="Email"
                        mandatory
                        name="email"
                        value={form.email}
                        onChange={handleChange}
                        error={errors.email}
                        type="email"
                        placeholder="Enter your email address"
                        required
                        className="w-full"
                    />

                    {/* Mobile */}
                    <CustomInput
                        label="Mobile Number"
                        mandatory
                        name="contact"
                        value={form.contact}
                        onChange={handleChange}
                        error={errors.contact}
                        type="contact"
                        placeholder="Enter your mobile number"
                        required
                        className="w-full"
                    />

                    {/* Password */}
                    <CustomInput
                        label="Password"
                        mandatory
                        name="password"
                        value={form.password}
                        onChange={handleChange}
                        error={errors.password}
                        type="password"
                        placeholder="New Password"
                        required
                        className="w-full"
                    />

                    {/* Confirm Password */}
                    <CustomInput
                        label="Confirm Password"
                        mandatory
                        name="confrimPassword"
                        value={form.confrimPassword}
                        onChange={handleChange}
                        error={errors.confrimPassword}
                        type="password"
                        placeholder="Confirm New Password"
                        required
                        className="w-full"
                    />

                    {/* Terms */}
                    <div className="flex items-start gap-2">
                        <input
                            type="checkbox"
                            name="isAgree"
                            checked={form.isAgree}
                            onChange={handleChange}
                            className="mt-1 cursor-pointer"
                            id='isAgree'
                        />
                        <label className="text-sm cursor-pointer" htmlFor='isAgree'>
                            By signing up, you agree to our{" "}
                            <span
                                className="text-primary-500 cursor-pointer"
                                onClick={() => setOpen("privacy")}
                            >
                                Terms & Privacy Policy
                            </span>
                        </label>
                    </div>

                    {errors.isAgree && (
                        <p className="text-red-500 text-sm">{errors.isAgree}</p>
                    )}

                    {/* Sign Up Button */}
                    {/* <div className="flex justify-center">
                        <Button
                            type="button"
                            disabled={!isValid && !otp}
                            onClick={handleSubmit}
                            variant="primary"
                            className={`w-60 h-12 text-white ${!isValid && otp ? "bg-primary-400" : "bg-gray-300"
                                }`}
                            children={"Sign Up"}
                        />
                    </div> */}

                    {/* Sign Up Button */}
                    <div className="flex justify-center">

                        <button
                            type='button'
                            disabled={!isValid}
                            onClick={handleSendOtpForSignup}
                            className={`w-60 h-12 text-white ${isValid ? "bg-primary-400" : "bg-gray-300"
                                } rounded-lg font-semibold`}
                        >Send OTP</button>
                    </div>
                </form>

                {/* Divider */}
                <div className="flex items-center gap-2 font-semibold">
                    <div className="w-full h-[2px] bg-gray-300"></div>
                    <p className="text-gray-600">or</p>
                    <div className="w-full h-[2px] bg-gray-300"></div>
                </div>

                {/* Login Redirect */}
                <div className="flex justify-center items-center gap-1 text-sm">
                    <p className="text-gray-700">Already have an account?</p>
                    <p
                        onClick={handleLogin}
                        className="font-semibold text-[#2C25C4] cursor-pointer"
                    >
                        Log in
                    </p>
                </div>
            </div>


            {
                message && (
                    <AlertMessage confirm={confirm} message={message} />
                )
            }

            {
                isOpen && (
                    <OTPController
                        email={form.email}
                        isOpen={isOpen}
                        onClose={setIsOpen}
                        setOtp={setOtp}
                        otp={otp}
                        purpose="signup"
                        setConfirm={setConfirm}
                        setIsOpen={setIsOpen}
                        Setmessage={Setmessage}
                        setSignUP={setSignUP}
                    />
                )
            }

            {open && <PrivacyPolicyModal isOpen={open} onClose={() => setOpen(false)} />}

        </AuthFormWrapper>
    )
}


